// 不需要鉴权
const constant = [
  // 根路径必须有落地组件：catch-all 把未匹配路径重定向到 '/'，若 '/' 没有对应路由，
  // 就会再次命中 catch-all 无限重定向，vue-router 抛 RangeError 导致整个应用白屏
  {
    path: '/',
    component: () => import('@/views/403.vue')
  },
  {
    path: '/share',
    component: () => import('@/views/project/edit/LineShareList.vue')
  },
  {
    path: '/GraphVisualizationShare',
    component: () => import('@/views/project/edit/GraphVisualizationShare.vue')
  },
  {
    path:'/Genshin',
    component: () => import('@/views/project/edit/LineShareListGame.vue')
  }
  , // 注册页面
  { path: '/:pathMatch(.*)', redirect: '/' }
]

export default [
  ...constant
]